module.exports = __webpack_public_path__ + "img/hr-tree-05-e-trunk.279d43c1.png";